module.exports = __webpack_public_path__ + "assets/img/home-prc.3e559e9a.png";